/* Mud Freaks scroll build-up (v56). Same behaviour as the Ice Freaks page:
   pieces below the fold (titles, text, photos, cards, buttons) fade and slide
   up as they reach the screen, staggered. The top block with the offer and
   Add to cart never moves. Anything above the viewport shows at once, and if
   this script fails everything is simply visible. */
(function(){
if(window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches)return;
var root=null,offer=null,pend=[];
var css=document.createElement('style');
css.textContent='html.mfa-ready #mfz .mfa{opacity:0;transform:translateY(28px);transition:opacity .65s ease,transform .8s cubic-bezier(.2,.8,.2,1)}'+
'html.mfa-ready #mfz img.mfa,html.mfa-ready #mfz video.mfa{transform:translateY(16px) scale(1.04)}'+
'html.mfa-ready #mfz .mfa.mfa-in{opacity:1!important;transform:none!important}';
document.head.appendChild(css);
var PIECES='h2,h3,p,img,video,blockquote,button,details,[style*="grid"] > *,[style*="flex-wrap"] > *';
function findOffer(){if(offer||!root)return;var b=[].filter.call(root.querySelectorAll('button'),function(x){return /add to cart/i.test(x.textContent||'');})[0];if(!b)return;var h=b;while(h.parentElement&&h.parentElement!==root)h=h.parentElement;offer=h;}
function mark(){root=root||document.getElementById('mfz');if(!root)return;findOffer();var vh=window.innerHeight;
[].forEach.call(root.querySelectorAll(PIECES),function(el){
if(el.dataset.mfa)return;el.dataset.mfa='1';
if(offer&&offer.contains(el))return;
if(el.closest('header,[id*=sticky],[class*=sticky]'))return;
if(el.parentElement&&el.parentElement.closest('.mfa'))return;
if(el.offsetParent===null)return;
var s=getComputedStyle(el);if(s.position==='fixed'||s.position==='sticky')return;
var r=el.getBoundingClientRect();
if(r.height>vh*0.9)return;
if(r.top<vh*0.95)return;
el.classList.add('mfa');pend.push(el);});
}
var raf=0;
function check(){raf=0;var vh=window.innerHeight,n=0,keep=[];
for(var i=0;i<pend.length;i++){var el=pend[i];if(!el.isConnected)continue;var r=el.getBoundingClientRect();
if(r.top<vh*0.92||r.bottom<0){el.style.transitionDelay=Math.min(n,6)*70+'ms';el.classList.add('mfa-in');n++;}else keep.push(el);}
pend=keep;}
function onScroll(){if(!raf)raf=requestAnimationFrame(check);}
window.addEventListener('scroll',onScroll,{passive:true});
window.addEventListener('touchmove',onScroll,{passive:true});
window.addEventListener('resize',onScroll,{passive:true});
function boot(){document.documentElement.classList.add('mfa-ready');mark();check();}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
var k=0;var iv=setInterval(function(){k++;mark();check();if(k>30)clearInterval(iv);},400);
setInterval(check,400);
})();
